<script lang="ts">
    import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import { REWARDS_SPENDING_RULE_TYPES } from "@apps/rewards/constants/rewardsSpendingRuleTypes";
    import type { RewardsSpendingRuleEntity } from "@apps/rewards/entities/entities";
    import RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    import RewardsCustomerStatusBasedContent from "../RewardsCustomerStatusBasedContent.svelte";
    import RewardsSpendingRulesFixedAmountReward from "./RewardsSpendingRulesFixedAmountReward.svelte";

    //Props
    export let rule: RewardsSpendingRuleEntity & {
        canRedeem: boolean;
        pointsToSpend: number;
        missingPoints: number;
    };
    export let isCustomer: boolean;
    export let pointsName: string;
    export let rewardsCurrencyFormatter: RewardsCurrencyFormatter;
    export let rewardsAmountFormatter: RewardsAmountFormatter;
    export let namespace: RewardsTranslationNamespaces;

    //Optional props
    export let variant: "primary" | "secondary" | "base" = "secondary";

    //Variables
    const translationKeys = {
        [REWARDS_SPENDING_RULE_TYPES.freeShipping]:
            "spending_rules_earn_more_to_get_discount",
        [REWARDS_SPENDING_RULE_TYPES.freeProduct]:
            "spending_rules_earn_more_to_get_free_product",
        [REWARDS_SPENDING_RULE_TYPES.giftCard]:
            "spending_rules_earn_more_to_get_gift_card",
    };
    const formattedMissingPoints$ = rewardsAmountFormatter.format(
        rule.missingPoints
    );

    //Reactive statement
    $: isCustomerContent = !rule.canRedeem && isCustomer;
</script>

<Text component="span" {variant} size="xs" compact>
    {#if rule.type === REWARDS_SPENDING_RULE_TYPES.fixedAmount}
        <RewardsCustomerStatusBasedContent {isCustomerContent}>
            <T
                slot="customer-content"
                {namespace}
                translationKey="spending_rules_earn_more_to_get_discount"
                translationOptions={{
                    points: $formattedMissingPoints$,
                    points_name: pointsName,
                }}
            />
            <RewardsSpendingRulesFixedAmountReward
                slot="default-content"
                discountValue={rule.discountValue}
                pointsPrice={rule.pointsPrice}
                {pointsName}
                {rewardsCurrencyFormatter}
                {namespace}
            />
        </RewardsCustomerStatusBasedContent>
    {:else if rule.type === REWARDS_SPENDING_RULE_TYPES.percentage}
        <RewardsCustomerStatusBasedContent {isCustomerContent}>
            <T
                slot="customer-content"
                {namespace}
                translationKey="spending_rules_earn_more_to_get_discount"
                translationOptions={{
                    points: $formattedMissingPoints$,
                    points_name: pointsName,
                }}
            />

            <T
                slot="default-content"
                {namespace}
                translationKey="spending_rules_percentage_reward"
                translationOptions={{
                    discount: Math.abs(rule.discountValue),
                    points: rule.pointsPrice,
                    points_name: pointsName,
                }}
            />
        </RewardsCustomerStatusBasedContent>
    {:else}
        <RewardsCustomerStatusBasedContent {isCustomerContent}>
            <T
                slot="customer-content"
                {namespace}
                translationKey={translationKeys[rule.type]}
                translationOptions={{
                    points: $formattedMissingPoints$,
                    points_name: pointsName,
                }}
            />

            <T
                slot="default-content"
                {namespace}
                translationKey="spending_rules_redeem_reward"
                translationOptions={{
                    points: rule.pointsPrice,
                    points_name: pointsName,
                }}
            />
        </RewardsCustomerStatusBasedContent>
    {/if}
</Text>
